import { Icon } from '@/app/_components/common/Icon';
import { Image } from '@/app/_components/common/Image';
import { Link } from '@/app_components/common/Link';
import type { Review } from '@/app_data/mock/ndrData';
import { trackGtmEvent } from '@/app_lib/utils/ndrUtils';

interface TableOfContentsProps {
  reviews: Review[];
  source: 'bing' | 'google';
  queryParams: string;
}

export const TableOfContents = ({ reviews, source, queryParams }: TableOfContentsProps) => {
  return (
    <div className='bg-white rounded-s shadow-md border border-neutral-200 p-6 xl:p-10'>
      <h3 className='text-2xl font-semibold text-gray-900 mb-6 border-b border-neutral-200 pb-2'>Read full reviews</h3>
      <ul className='flex flex-col gap-2'>
        {reviews.map((review) => (
          <li
            className='flex items-center justify-between'
            key={review.companySlug}
          >
            <Link
              className='flex items-center justify-between transition-colors group'
              href={`/reviews${source === 'google' ? '-1' : '-2'}/${review.companySlug}?${queryParams}`}
              onClick={() => {
                trackGtmEvent(`/reviews${source === 'google' ? '-1' : '-2'}/${review.companySlug}?${queryParams}`);
              }}
              rel='noopener noreferrer'
              target='_blank'
            >
              <div className='flex items-center'>
                {review.companyLogos.reviewCard && (
                  <div className='relative w-12 h-8 flex-shrink-0 flex items-center justify-center'>
                    <Image
                      alt={`${review.companyName} logo`}
                      className='object-contain'
                      height={24}
                      src={review.companyLogos.reviewCard}
                      width={40}
                    />
                  </div>
                )}
                <span className='font-medium text-base text-blue-500 group-hover:underline transition-colors ml-3'>
                  {review.companyName}
                </span>
                <Icon
                  className='text-blue-500'
                  height={20}
                  icon='ChevronRight'
                  width={22}
                />
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
